import React from 'react';

// Lien vers la charte et l'information RGPD, affiché en bas de chaque page.
// Lien HTML simple (et non <Link>) : certains écrans qui l'affichent sont
// rendus hors du routeur (compte en attente, choix du site, etc.).
const LegalFooter = ({ className = '' }) => (
  <p className={`text-center text-xs mt-8 ${className}`} data-testid="legal-footer">
    <a href="/charte" className="underline underline-offset-2 hover:opacity-80">
      Charte et données personnelles
    </a>
  </p>
);

export default LegalFooter;
